import React from 'react';
import { generateColor } from '../util';

var ColorClear = function ColorClear(_ref) {
  var prefixCls = _ref.prefixCls,
      value = _ref.value,
      colorCleared = _ref.colorCleared,
      onChange = _ref.onChange;

  var handleClick = function handleClick() {
    if (value && !colorCleared) {
      var hsba = value.toHsb();
      hsba.a = 0;
      var genColor = generateColor(hsba);
      onChange === null || onChange === void 0 ? void 0 : onChange(genColor);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-clear"),
    onClick: handleClick
  });
};

export default ColorClear;